import { ref, readonly } from 'vue'

// Module-level singleton — works from plain functions and Options API components
const visible = ref(false)
const text = ref('')

export function showOverlay(message: string) {
  text.value = message
  visible.value = true
}

export function updateOverlayText(message: string) {
  text.value = message
}

export function hideOverlay() {
  visible.value = false
  text.value = ''
}

export function useOverlay() {
  return {
    overlayVisible: readonly(visible),
    overlayText: readonly(text),
    showOverlay,
    updateOverlayText,
    hideOverlay,
  }
}
